export default {
    // 公共
    c: {
        input: 'Please input ',
        select: 'Please select ',
        please: 'Please ',

        operation: 'Operation',
        tip: 'Tip',
        login: 'Login',
        logout: 'Logout',
        search: 'Search',
        export: 'Export',
        add: 'Add ',
        edit: 'Edit',
        cancel: 'Cancel',
        confirm: 'Confirm',
        detail: 'Detail',
        delete: 'Delete',
        refresh: 'Refresh',
        view: 'View ',
        start: 'Start',
        pause: 'Pause',
        stop: 'Stop',
        quit: 'Quit',
        remove: 'Remove',
        check_all: 'Check All',
        clear_all: 'Clear All',
        generate: 'Generate',
        close: 'Close',
        open: 'Open',
        parse: 'Parse',
        reset: 'Reset',

        unknown: 'Unknown',
        user: 'User',
        data: 'Data',
        content: 'Content',
        coordinate: 'Coordinate',
        longitude: 'Longitude',
        latitude: 'Navigate',
        create_time: 'Create Time',
        begin_time: 'Begin Time',
        end_time: 'End Time',
        status: 'Status',
        type: 'Type',
        task: 'Task',
        target: 'Target',
        setting: 'Setting',

        select_user: 'Select User',
        select_device: 'Select Device',

        oper_success: 'Operate Success',
        oper_failure: 'Operate Failure',
        upload_failure: 'Upload Failure',
        upload_success: 'Upload Success',        
    },
    unit: {
        meter: ' meter',
        ms: ' ms',
        byte: ' byte',
        day: ' day',
    },
    tip: {
        welcome: 'Hello！Welcome to HORWIN IOT platform.',

        please_login: 'Please Login',

        ask_logout: 'Are you sure you want to log out ?',

        no_identity: 'The current identity cannot be accessed',
    },
    title: {
        overview: 'Overview',
        device_management: 'Device',
        vehicle_26001: 'Vehicle-26001',
        vehicle_26003: 'Vehicle-26003',
        vehicle_26004: 'Vehicle-26004',
        vehicle_26007: 'Vehicle-26007',
        bms_26005: 'BMS-26005',
        bms_26006: 'BMS-26006',
        vehicle_detail: 'Vehicle Detail',
        bms_detail: 'BMS Detail',
        OTA: 'OTA',
        task_list: 'Task List',
        task_detail: 'Task Detail',
        user_management: 'User',
        user_list: 'User List',
        user_detail: 'User Detail',

        admin_management: 'Admin',
        admin_list: 'Admin List',
        admin_detail: 'Admin Detail',

        tool_management: 'Tool',
        parser_26005: '26005-Parser',
    },

    // 账号
    user: {
        auth: 'Authority',
        admin: 'Admin',
        client: 'Client',
        username: 'Username',
        password: 'Password',
        ask_delete_title: 'Make  sure you want to delete this user?',
        ask_delete_content: 'After deleted, all data of the user will be deleted from the platform',

        notify_url: 'Notify Url',
        addr: 'Addr',
        addr_extra: 'Addr Extra',
        addr_profile: 'Addr Profile',
        addr_config: 'Addr Config',
        relay_mqtt_enable: 'Relay MQTT Enable',

        tip_configure_current: 'Please configure the current routing information first',
        tip_address_exists: 'The route address already exists.',
        tip_format_error: 'The format of the route address is incorrect',
        tip_type_exists: 'The type has been configured',
    },
    // 首页
    home: {
        device_stat: 'Device Statistics',
        device_count: 'Device Count',
        device_online_count: 'Online Count',
        device_offline_count: 'Offline Count',
        device_warning_count: 'Warning Count',
    },


    // 设备
    device: {
        device: 'Device',
        device_uid: 'UID',
        last_active_time: 'Last Active Time',

        online_status: 'Status',
        status: {
            all: 'All',
            online: 'Active',
            offline: 'Inactive',
        },

        device_space: 'Space',
        space: {
            "26001": "Vehicle-26001",
            "26003": "Vehicle-26003",
            "26004": "Vehicle-26004",
            "26007": "Vehicle-26007",
            "26005": "BMS-26005",
            "26006": "BMS-26006",
        },
        vehicle: 'Vehicle',

        distribute: 'Distribute',
        distributed: 'Has been distributed',
        no_distribute: 'No distribute',
        expire_time: 'Expire Time',

        clear_cache: 'Clear Cache',
        clear_cache_ask: 'Are you sure to clear the route cache for this device?',
        export_ask: 'Are you sure to export device?',

        DeviceInfo: "Device Info",
        EventList: "Event List",
        FrameList: "Frame List",
        CommandList: "Command List",
        RelayLog: "Relay Log",

        base_info: 'Base Info',
        imsi:'IMSI',
        imei:'IMEI',
        iccid:'ICCID',
        latitude:'Latitude',
        longitude:'Longitude',
        speed:'Speed',
        angle: 'Angle',
        navigate:'navigate',
        last_gps_report_time:'Last GPS Report Time',
        gsm_signal_strength:'GSM Signal Strength',
        gps_signal_strength:'GPS Signal Strength',
        gps_state:'GPS State',
        voltage:'Voltage',
        current:'Current',
        soc:'SOC',
        temperature_sensor: 'Temperature Sensor',
        temperature:'Temperature',
        remaining_capacity:'Remaining Capacity',
        full_charge_capacity:'Full Charge Capacity',
        cycle_count:'Cycle Count',
        rated_capacity:'Rated Capacity',
        rated_voltage:'Rated Voltage',
        version:'Version',
        manufacture_date:'Manufacture Date',
        manufacture_name:'Manufacture Name',
        name:'Name',
        chem_id:'Chem Id',
        dtu_software_version:'DTU Version',
        bms_software_version:'BMS Version',
        bluetooth_mac:'BLE MAC',
        last_active_time:'Last Active Time',
        gnss_satellite_used_count:'GNSS satellite count',
        gprs_apn:'GPRS APN',
        gprs_total_data_used:'GPRS total data used',
        gps_satellite_in_view_count:'GPS satellite count in view',
        iot_temperature:'DTU temperature',
        bms_bar_code:'BMS bard code',
        bms_id:'BMS ID',
        BMS:'BMS',
        DTU:'DTU',
        location:'Location',
        location_angle: 'Location Angle',
        low_cell_voltage: 'Low Cell Voltage',
        high_cell_voltage: 'High Cell Voltage',
        battery_most_value_log: 'Battery Most Value Log',
        error_count: 'Error Count',
        battery_status: 'Battery Status',
        bluetooth_password: 'Bluetooth Password',
        gprs_stat: 'GPRS statistic',

        module_access_parameters: 'Module Access Parameters',
        server_addr: 'server addr',
        OM_server_addr: 'O&m server addr',
        activate_module_upgrade: 'Activate module upgrade',
        module_upgrade: 'Module upgrade',
        bms_upgrade: 'BMS upgrade',
        set_battery: 'Set battery',
        electronic_fence: 'Electronic Fence',
        fence_radius: 'Fence radius',


        bms_count: 'BMS Count',
        bms_1_sn: 'BMS Sn',
        bms_2_sn: 'BMS2 Sn',
        charge_count: ' Charge Count',
        discharge_count: ' Discharge Count',
        max_temperature: ' Max Temperature',

        vcu_version: 'VCU Version',

        bms_version: 'BMS Version',

        ota_result: 'OTA Result',
        ota_version: 'OTAV Version',
        ota_id: 'OTA ID',

        location_status: 'Location Status',
        location_north_south: 'Location North South',
        location_east_west: 'Location East West',
        location_longitude: 'Location Longitude',
        location_latitude: 'Location Latitude',
        location_speed: 'Location Speed',
        location_satellite_count: 'Location Satellite Count',
        location_coordinate: "Location Coordinate",
        location_direction: "Location Direction",
        location_type: "Location Type",
        location_valid: "Location Valid",
        location_altitude: "Location Altitude",

        max_speed: 'Max Speed',

        battery_status: 'Battery Status',
        vcu_soc: 'VCU Soc',
        battery_soc: 'Battery Soc',
        battery_temperature: 'Battery Temperature',
        battery_cycle_count: 'Battery Cycle Count',
        battery_charge_remaining_time: 'Battery Charge Remaining Time',

        guard_alarm_status: 'Guard Alarm Status',

        warning: 'Warning',

        lock_result: 'Lock Result',

        bms_config_set_result: 'BMS Config Set Result',

        check_vcu_mode: 'Check-VCU工作模式',
        check_vcu_error: 'Check-VCU Error',
        check_mcu_mode: 'Check-MCU Mode',
        check_mcu_error: 'Check-MCU Error',
        check_bms_1_mode: 'Check-BMS1 Mode',
        check_bms_1_error: 'Check- BMS1 Error',
        check_bms_2_mode: 'Check-BMS2 Mode',
        check_bms_2_error: 'Check-BMS2 Error',
        check_hmi_mode: 'Check-HMI Mode',
        check_bc_error: 'Check-BC Error',

        heartbeat_interval: 'Heartbeat Interval',

        server_addr: 'Server Addr',

        locate_interval_acc_on: 'ACC ON Locate Interval',
        locate_interval_acc_off: 'ACC OFF Locate Interval',
        target_type:'Target Type',

        rear_wheel_speed_ratio: 'Rear Wheel Speed Ratio',
        front_wheel_speed_ratio: 'Front Wheel Speed Ratio',
        drive_ratio: 'Drive Ratio',
        remaining_mileage_ratio: 'Remaining Mileage Ratio',
        cut_off_voltage_threshold: 'Cut Off Voltage Threshold',
        over_voltage_protect_threshold: 'Over Voltage Protect Threshold',
        over_current_protect_threshold: 'Over Current Protect Threshold',
        leak_voltage_protect_threshold: 'Leak Voltage Protect Threshold',
        motor_pole_pair_count: 'Motor Pole Pair Count',
        reverse_charge_current: 'Reverse Charge Current',

        chem_id: "Chem Id",
        system_error_status: 'System Error Status',
        cell_voltage: 'Cell Voltage',
        cell_voltage_1: 'Cell Voltage 1',
        cell_voltage_2: 'Cell Voltage 2',
        history: 'History Log',

        frame_type: 'Frame Type',
        timestamp: 'Timestamp',
        packet_id: 'Packet Id',
        bms_time: 'Bms Time',

        software_version: 'Software Version',
        hardware_version: 'Hardware Version',
        firmware_index_code: 'Firmware Index Code',

        maximum_discharge_current: 'Maximum Discharge Current',
        maximum_charging_current:  'Maximum Charging Current',
        maximum_cell_voltage: 'Maximum Cell Voltage',
        minimum_cell_voltage: 'Minimum Cell Voltage',
        maximum_battery_pack_temperature: 'Maximum Battery Pack Temp',
        minimum_battery_pack_temperature: 'Minimum Battery Pack Temp',

        ota_type: 'OTA Task Type',
        ota_error_code: 'OTA Error Code',
        ota_state_code: 'OTA State Code',

        protocol_version: "Protocol version",
        signal_strength: "Signal strength",
        satellite_count: "Number of satellites",        
        mileage_curr: "Current mileage",
        mileage_total: "Total mileage",
        mileage_endurance: "Mileage endurance",
        battery_power: "Battery level",
        lock_status: "Locked state",
        boot_status: "Enabled state",
        ecu_battery: "Car computer battery",
        ecu_gps_status: "Car computer GPS status",
        last_status_report_time: "Last reported time",

        battery_soh: "SOH",                    
        battery_status: "Battery Status",                    
        battery_current_threshold: "Battery Current Threshold",                    
        battery_charge_count: "Battery Charge Count",
        battery_discharge_count: "Battery Discharge Count",
        battery_cell_voltage: "Battery Cell Voltage",

        remaining_mileage: "Remaining Mileage",
        torque: "Torque",
        mcu_temperature: "Mcu Temperature",
        mcu_engine_temperature: "Mcu Engine Temperature",
        mcu_status: "Mcu Status",
        gear: "Gear",
        reverse_energy_recovery: "Reverse Energy Recovery",

        vcu_base_info: "Vcu Base Info",
        mcu_base_info: "Mcu Base Info",
        hmi_base_info: "Hmi Base Info",
        charger_base_info: "Charger Base Info",
        hardware_version_number: "hardware Version Number",
        software_version_number: "software Version Number",
        vendor: "Vendor",
        Battery: "Battery",        
    },
    // 数据帧
    frame: {
        original_data: 'Original Data',
        frame_data: 'Frame Data',

        illegal_data_packet: 'Illegal data packet',

        charge_status: {
            not_charging: 'Not charging',
            charging: 'Charging',
            fully_charged: 'Fully charged',
            time_is_up: 'Time is up',
        },
        overload: 'Overload',
        overcurrent: 'Overcurrent',
        overtemperature: 'Over-temperature',
        no_load: 'No_load',
        electric_meter_failure: 'Electric meter failure',
        metering_circuit_fault: 'Metering circuit fault',
        electric_leakage: 'Electric leakage',
        cp_status_is_abnormal: 'CP status is abnormal.',
        charging_gun_insertion: 'Charging gun insertion',

        login: 'Login',
        vehicle_status: 'Vehicle Status',
        node: 'NODE ',
        port: 'PORT ',
        failure: 'Failure',
        success: 'Success',

        type: {
            login: 'Login',
            authentication: 'Authentication',
            warning:'Warning',
            escalation:'Report',
            heartbeat: 'Heartbeat',

            login_success : 'Login Success',
            receive_success: 'Receive Success',
            get_data : 'Get Data',
            remote_control  : 'Remote Control',

            request_access: 'Request Access',
            request_update_session_key: 'Request Update Session Key',
            up_link_data: 'Uplink Data',
            report_fota_version: 'Report Fota Version',
            response_ota_task: 'Response Ota Task',
            request_down_fota_data: 'Request Down Fota Data',
            notification_upgrade_result: 'Notify Upgrade Result',
        },

        valid: 'Valid',
        invalid: 'Invalid',

        device_status: {
            '0_0': 'USB power',
            '0_1': 'Real Light Status',
            '0_2': 'Charger Indentify Status',
            '0_3': 'Charger Connection',
            '0_4': 'Pre Charge Circuit',
            '0_5': 'Pre Discharge Circuit',
            '0_6': 'Discharge Mosfet',
            '0_7': 'Charge Mosfet',

            '1_7': 'Battery Charging Stopped Flag',

            '2_0': 'Protection Chip Error',
            '2_1': 'Cell Drop Error',
            '2_2': 'Imbanlance',
            '2_3': 'Estimate Error',
            '2_4': 'Record Error',
            '2_5': 'RTC Error',
            '2_6': 'Discharging Mosfet Error',
            '2_7': 'Charging Mosfet Error',

            '3_0': 'Over Charge',
            '3_1': 'Primary Over Discharge',
            '3_2': 'Secondary Over Discharge',
            '3_3': 'Primary Over Current',
            '3_4': 'Secondary Over Current',
            '3_5': 'Over Charge Current',
            '3_6': 'Pre-Start Fail',
            '3_7': 'Pre-Charge Over time',

            '4_0': 'MOS Temperature Sensor Error',
            '4_1': 'Cell Temperature Sensor Error',
            '4_2': 'Over Discharge Temperature',
            '4_3': 'Over Charge Temperature',
            '4_4': 'Under Discharge Temperature',
            '4_5': 'Under Charge Temperature',
            '4_6': 'Over Temperature of Discharge Mosfet',
            '4_7': 'Over temperature of Charge Mosfet',

            '5_0': 'Over temperature of Pre-Start circuit',
            '5_4': 'Third Over Current',
            '5_6': 'Config Data Error',

            '6_0': 'Protection Chip Error',
            '6_1': 'Cell Drop Error',
            '6_2': 'Imbanlance',
            '6_3': 'Estimate Error',
            '6_4': 'Record Error',
            '6_5': 'RTC Error',
            '6_6': 'Discharging Mosfet Error',
            '6_7': 'Charging Mosfet Error',

            '7_0': 'Over Charge',
            '7_1': 'Primary Over Discharge',
            '7_2': 'Secondary Over Discharge',
            '7_3': 'Primary Over Current',
            '7_4': 'Secondary Over Current',
            '7_5': 'Over Charge Current',
            '7_6': 'Pre-Start Fail',
            '7_7': 'Pre-Charge Over time',

            '8':  'Battery SOC ',
            '9':  'Battery SOH',
            '10': 'Pack Voltage',
            '14': 'Real time Current',
            '18': 'Highest cell Temp(real time)',
            '19': 'Lowest cell Temp(real time)',
            '20': 'Mosfet Temp',
            '21': 'Pre-start Temp',
            '22': 'Maximum Charge Current',
            '23': 'Discharging message',
            '24': 'Cycle Counter',
        },
        real_time: "Real Time",
        lately: "Lately",
    },
    // 事件
    event: {
        report_time: 'Report Time',
        report_type: 'Report Type',
        event_type: 'Event Type',
        type: {
            connect: 'Connect',
            break: 'Break',
        }
    },
    // 命令
    command: {
        status: {
            wait:    "Waiting",
            issued:  "Issued",
            respond: "Responded",
            failure: "Failure",
        },
        type: {
            '0x01': 'Issued configuration',
            '0x02': 'Obtaining node status',
            '0x03': 'Obtaining node config',
            '0x04': 'Set up parameters',
            '0x05': 'Set socket system parameters',
            '0x06': 'Control',
            '0x07': 'Networking',
            '0x08': 'Add node',
            '0x09': 'Delete node',
            '0x0A': 'Upgrade',
            '0x0B': 'Card charging control',
            '0x0C': 'Query card balance response',
            '0x0D': 'Set the voice broadcast configuration',
            '0x31': 'Card begin charge and respond',
            '0x32': 'Card finish charge and respond',
        },

        request_id: 'Request ID',
        request_type: 'Request Type',
        request_time: 'Request Time',
        request_data: 'Request Data',
        request_data_type: {
            plug_heartbeat: "Event plug heartbeat",
            charge_finished: "Event charge finished",
            gateway_heartbeat: "Event gateway heartbeat",
            plug_mp_heartbeat: "Event plug mp heartbeat",
            charge_finished_3: "Event charge finished",
            card_charge_started: "Event card charge started",
            card_charge_finished: "Event card charge finished",
        },

        response_time: 'Response Time',
        response_data: 'Response Data',
        response_empty: 'No Response Data',

        elapsed_time: 'Elapsed Time',

        notify_url: 'Notify Url',
        retry_count: 'Retry Count',

        "26001": {
            GET_GPS: 'Get GPS',
            GET_STATUS: 'Get Status',
            GET_BMS: 'Get BMS Info',
            CHECK_VEHICLE: 'Check Vehicle',
            CHECK_BMS: 'Check BMS',
            CHECK_METER: 'Check Meter',
            CHECK_ECU: 'Check ECU',
            CHECK_CONTROLLER: 'Check Controller',
            LOCK: 'Lock',
            UNLOCK: 'Unlock',
            UNLOCK_SEAT: 'Unlock Seat',
            UNLOCK_TAIL_BOX: 'Unlock Tail Box',
            BOOT: 'Boot',
            SHUTDOWN: 'Shutdown',
            REBOOT: 'Reboot',
        },
        "26003": {
            launch: 'Launch',
                turn_on: 'Turn On',
                turn_off: 'Turn Off',
            reboot: 'Reboot',
            check: 'Check',

            getGsmGpsStatus: 'Get GSM/GPS Status',
            getLocation: 'Get Location',
            getHistoryLocation: 'Get History Location',
            getBattery: 'Get Battery Status',

            setBMS: 'Set BMS Info',
                please_input_index: 'Please input Index',
                please_input_bms_info: 'Please input BMS Info',
                please_input_time_out_period: 'Please input Time Out Period',

            setServerAddr: 'Set Server Addr',

            getGuard: 'Get Guard Status',
            setGuard: 'Set Guard Status',
                defenses: 'Defenses',
                undefenses: 'No Defenses',

            getLock: 'Get Lock Status',
            setLock: 'Set Lock Status',
                lock: 'Lock',
                unlock: 'Unlock',

            getHeartbeatInterval: 'Get Heartbeat Interval',
            setHeartbeatInterval: 'Set Heartbeat Interval',

            getAPN: 'Get APN',
            setAPN: 'Set APN',

            getLocateInterval: 'Get Locate Interval',
            setLocateInterval: 'Set Locate Interval',
            please_input_acc_on_interval: 'Please input ACC ON Interval',
            please_input_acc_off_interval: 'Please input ACC OFF Interval',
            getModuleInfo: 'Get Component Information',
            getMileage: 'Earn miles',

            setHmiParams: 'Set HMI Params',
            setBmsParams: 'Set BMS Params',
            setMcuParams: 'Set MCU Params',
        },
        "26004": {},
        "26005": {
            getInfo1: 'Get Info 1',
            getInfo2: 'Get Info 2',
            getInfo3: 'Get Info 3',

            set_gprs_apn:'Set GPRS APN',

            set_bluetooth_password: 'Set Bluetooth Password',

            set_module_access_parameters: 'Set Module Access Parameters',
                set_server_addr: 'Set server addr',
                set_OM_server_addr: 'Set O&m server addr',

            activate_module_upgrade: 'Activate module upgrade',
                module_upgrade: 'Module upgrade',
                bms_upgrade: 'BMS upgrade',

            set_battery: 'Set battery',
                usb_power: 'USB power',
                light_status: 'Real Light Status',
                charger_indentify_status: 'Charger Indentify Status',
                charger_connection: 'Charger Connection',
                pre_charge_circuit: 'Pre Charge Circuit',
                pre_discharge_circuit: 'Pre Discharge Circuit',
                discharge_mosfet: 'Discharge Mosfet',
                charge_mosfet: 'Charge Mosfet',
                battery_charging_stopped_flag: 'Battery Charging Stopped Flag',

            set_electronic_fence: 'Set Fence',
                fence_radius: 'Fence radius',
        },
        "26006": {
            getInfo1: 'Get Info 1',
            getInfo2: 'Get Info 2',
            getInfo3: 'Get Info 3',

            set_gprs_apn:'Set GPRS APN',

            set_bluetooth_password: 'Set Bluetooth Password',

            set_module_access_parameters: 'Set Module Access Parameters',
                set_server_addr: 'Set server addr',
                set_OM_server_addr: 'Set O&m server addr',

            activate_module_upgrade: 'Activate module upgrade',
                module_upgrade: 'Module upgrade',
                bms_upgrade: 'BMS upgrade',

            set_battery: 'Set battery',
                usb_power: 'USB power',
                light_status: 'Real Light Status',
                charger_indentify_status: 'Charger Indentify Status',
                charger_connection: 'Charger Connection',
                pre_charge_circuit: 'Pre Charge Circuit',
                pre_discharge_circuit: 'Pre Discharge Circuit',
                discharge_mosfet: 'Discharge Mosfet',
                charge_mosfet: 'Charge Mosfet',
                battery_charging_stopped_flag: 'Battery Charging Stopped Flag',

            set_electronic_fence: 'Set Fence',
                fence_radius: 'Fence radius',
        },
        "26007": {},
        custom_read: 'Custom Read',
    },


    // OTA
    task: {
        status: {
            init: 'Init',
            upgrading: 'Upgrading',
            paused: 'Paused',
            finish: 'Finish',
            stop: 'Stop',
        },
        member_status: {
            init: 'Init',
            in_preparation: 'In preparation',
            upgrading: 'Upgrading',
            success: 'Success',
            failure: 'Failure',
            fail_in_get_file: 'Failed to get upgrade file information',
            fail_in_set_file: 'Failed to temporarily store the upgrade file locally',
            fail_in_get_data: 'Failed to obtain the fragment data.',
        },
        upgrade_status: {
            leisure: 'Leisure',
            upgrading: 'Upgrading',
        },
        ask_delete: 'Are you sure you want to delete this task?',
        ask_remove_member: 'Are you sure you want to remove the device from the task?',

        task_name: 'Task Name',
        task_status: 'Task Status',
        target_version: 'Target Version',
        target_version_code:'Version Code',

        plan: 'Plan ',
        plan_time: 'Plan Time',

        processing_count: 'Processing Count',
        success_count: 'Success Count',
        total_count: 'Total Count',
        success_total_count: 'Success/Total Count',

        upload_file: 'Upload Update File',
        file_qrcode: 'Task QR Code',
        pack_size: 'Data pack size',
        pack_wait: 'Data pack wait',

        add_member: 'Add Task Member',
        import_member: 'Import Task Member',
        task_member: 'Task Member',
        member_list: 'Member List',

        progress: 'Progress',
        curr_version: 'Current Version',
        send_success: ' Command was sent successfully',
        download_template: 'Download Template',
        download_failure: 'Download Failure',
        download_success: 'Download Success',
    },
    file: {
        name: 'File Name',
        version: 'Version',
        hash: 'File Hash',
        size: 'File Size',
        upload: 'Upload File',
        select: 'Select File',
    },

    // 工具
    tool: {
        unpack_result: 'Unpack Result'
    },

    // OTA参数
    OTA: {
        ota_data_length: "OTA Data Length",
        ota_data_offset: "OTA Data Offset",       
        ota_type: "OTA Type",
            transfer_confirmation : "Upgrade transfer/confirmation",
            fragment_transmission: "Data fragment transmission",
            Transmission_complete: "Transmission complete",
        ota_state_code: "OTA State Code",
            upgrade_successfully:"Upgrade successfully",
            upgrade_failure:"Upgrade failure",
            file_check_error:"File check error",
            firmware_version:"The firmware version is the latest",
    }
}